export const host_device_ip = 'pongthegame.xyz'
export const nginx_port = 443
